<script>
	import { onMount } from 'svelte';
	import Column from './weapon-column.svelte';
	import Weapon from './weapon-item.svelte';
	import Armor from './armor-item.svelte';
	import Inventory from './inventory-item.svelte';

	let name = 'test';
	let width;
	let height;
	let background;
	let uiLayer;
	let main;
	let money = 7500;
	let moneyPeak;
	let inventory = {
		'knife': {
			id: 'knife',
			label: 'Throwing Knife',
			icon: 'images/T_TacticKnife.png',
			ammo: 0,
		},
		'pistol': undefined,
		'smg': undefined,
		'rifle': undefined,
		'smoke': undefined,
		'flash': undefined,
		'he': undefined,
	};

	let pistols = ['glock17', 'deserteagle'];
	let smgs = ['mac10', 'mp5a2', '590a1'];
	let rifles = ['ak47', 'm16a2', 'famas', 'auga1', 'ssrmk20', 'm40'];
	let grenades = ['flash', 'smoke', 'he'];
	let armor = ['head', 'torso', 'legs', 'nv'];
	let categories = {
		'Pistol': pistols,
		'SMG / Shotgun': smgs,
		'Rifle': rifles,
		'Grenade': grenades,
		'Armor': armor
	};

	let itemData = {
		'glock17': {
			id: 'glock17',
			icon: 'images/T_Glock17.png',
			label: 'Glock17',
			price: 300,
			magPrice: 20,
		},
		'deserteagle': {
			id: 'deserteagle',
			icon: 'images/T_DesertEagle.png',
			label: 'Desert Eagle',
			price: 500,
			magPrice: 25,
		},
		'mac10': {
			id: 'mac10',
			icon: 'images/T_Mac10.png',
			label: 'MAC-10',
			price: 1100,
			magPrice: 30,
		},
		'mp5a2': {
			id: 'mp5a2',
			icon: 'images/T_MP5A2.png',
			label: 'MP5A2',
			price: 1500,
			magPrice: 40,
		},
		'590a1': {
			id: '590a1',
			icon: 'images/T_Mossberg.png',
			label: '590A1',
			price: 1500,
			magPrice: 32,
			shellPurchaseCount: 8,
			maxAmmo: 48,
		},
		'ak47': {
			id: 'ak47',
			icon: 'images/T_AK47.png',
			label: 'AK-47',
			price: 3200,
			magPrice: 50,
		},
		'm16a2': {
			id: 'm16a2',
			icon: 'images/T_M16A2.png',
			label: 'M16A2',
			price: 3850,
			magPrice: 50,
		},
		'famas': {
			id: 'famas',
			icon: 'images/T_FAMAS.png',
			label: 'FAMAS',
			price: 3900,
			magPrice: 50,
		},
		'auga1': {
			id: 'auga1',
			icon: 'images/T_AugA1.png',
			label: 'Aug A1',
			price: 4600,
			magPrice: 50,
		},
		'ssrmk20': {
			id: 'ssrmk20',
			icon: 'images/T_MSG90.png',
			label: 'SSR MK20',
			price: 4800,
			magPrice: 40,
		},
		'm40': {
			id: 'm40',
			icon: 'images/T_M40_1.png',
			label: 'M40',
			price: 7500,
			magPrice: 80,
		},
		'flash': {
			id: 'flash',
			icon: 'images/T_Flash.png',
			label: 'Flashbang',
			price: 300,
		},
		'smoke': {
			id: 'smoke',
			icon: 'images/T_Smoke.png',
			label: 'Smoke',
			price: 400,
		},
		'he': {
			id: 'he',
			icon: 'images/T_HEGrenade.png',
			label: 'High Explosive',
			price: 500,
		},
		'knife': {
			id: 'knife',
			icon: 'images/T_TacticKnife.png',
			label: 'Throwing Knife',
			magPrice: 10,
			maxAmmo: 10,
		},
		'head': {
			id: 'head',
			icon: 'images/helmet.png',
			price: 250,
		},
		'torso': {
			id: 'torso',
			icon: 'images/torso.png',
			price: 350,
		},
		'legs': {
			id: 'legs',
			icon: 'images/legs.png',
			price: 300,
		},
		'nv': {
			id: 'nv',
			icon: 'images/night_vision.png',
			price: 100,
		},
	}

	onMount(() => {
		let scale = Math.min(
			window.innerWidth / 2562,
			window.innerHeight / 1440
		);
		main.style.setProperty('transform', `scale(${scale})`);
	});

	function getItemCategory(id) {
		if (pistols.includes(id)) {
			return 'pistol';
		}
		if (smgs.includes(id)) {
			return 'smg';
		}
		if (rifles.includes(id)) {
			return 'rifle';
		}
		if (armor.includes(id)) {
			return 'armor';
		}
		if (grenades.includes(id)) {
			return 'grenade'
		}
	}

	function calculatePrice(id) {
		const category = getItemCategory(id);
		const inventoryItem = inventory[category];
		const selectedItem = inventoryItem && itemData[inventoryItem.id];
		const item = itemData[id];
		const itemPrice = calculateItemPrice(id);

		let workingPrice = money;
		if (selectedItem !== item && selectedItem && selectedItem.price) {
			workingPrice += calculateItemPrice(selectedItem.id);
		}

		workingPrice += item.isSelected ? itemPrice : -itemPrice;

		return workingPrice;
	}

	function calculateItemPrice(id) {
		const category = getItemCategory(id);
		const selectedItem = inventory[category];
		const item = itemData[id];
		let workingPrice = item.price;

		if (item.isSelected && selectedItem && selectedItem.ammo > 0) {
			let ammo = selectedItem.ammo;
			if (item.shellPurchaseCount) {
				ammo = ammo / item.shellPurchaseCount;
			}
			workingPrice += ammo * item.magPrice;
		}

		return workingPrice;
	}

	function selectItem(id) {
		const data = itemData[id];
		if (data.isSelected) {
			return;
		}
		money = calculatePrice(id);
		data.isSelected = true;
		if (!data.label) {
			return;
		}
		const inventoryData = {
			id: id,
			icon: data.icon,
			label: data.label,
		}

		const category = getItemCategory(id);
		if (category !== 'grenade') {
			inventoryData.ammo = 0;
			if (inventory[category]) {
				deselectItem(inventory[category].id, true);
			}
			inventory[category] = inventoryData;
		} else {
			inventory[id] = inventoryData;
		}
	}

	function deselectItem(id, skipPriceModification) {
		const category = getItemCategory(id);
		if (id === 'knife') {
			return;
		}
		if (!skipPriceModification) {
			money = calculatePrice(id);
		}
		if (category !== 'grenade') {
			inventory[category] = undefined;
		} else {
			inventory[id] = undefined;
		}

		const data = itemData[id];
		data.isSelected = false;
	}

	function updateDisabled() {
		const keys = Object.keys(itemData);
		for (const key of keys) {
			const item = itemData[key];
			const category = getItemCategory(item.id);
			const selectedItem = inventory[category] && itemData[inventory[category].id];
			let workingMoney = money;
			if (selectedItem) {
				workingMoney += selectedItem.price;
			}
			if (item.isSelected) {
				workingMoney += item.price + 1;
			}
			item.isDisabled = item.price > workingMoney;
			itemData[key] = {...item};
		}
	}

	function onWeaponClick(event, item) {
		if (item.isSelected) {
			deselectItem(item.id);
		} else {
			selectItem(item.id);
		}
		updateDisabled();
		itemData = {...itemData};
	}

	function onWeaponRightClick(event, item) {
		event.preventDefault();
		const category = getItemCategory(item.id)
		if (category !== 'grenade' || category !== 'armor') {
			if (category === 'armor' && item.id !== 'nv') {
				selectItem('head');
				selectItem('torso');
				selectItem('legs');
				itemData = {...itemData};
				return;
			}

			if (!item.isSelected) {
				selectItem(item.id);
			}
			if (inventory[category]) {
				addMagazine(null, inventory[category], true);
			}
		}
		itemData = {...itemData};
	}

	function onWeaponHover(item) {
		moneyPeak = calculatePrice(item.id);

		return () => {moneyPeak = undefined}
	}

	function addMagazine(event, item, shouldMaxOut) {
		if (event) {
			event.preventDefault();
		}
		const data = itemData[item.id];
		const max = data.maxAmmo || 5;
		const startingAmmo = item.ammo;
		if (item.ammo !== undefined) {
			item.ammo += data.shellPurchaseCount || 1;
			if (shouldMaxOut) {
				item.ammo = max;
			}
			if (item.ammo > max) {
				item.ammo = max;
			}

			let diff = item.ammo - startingAmmo;
			if (data.shellPurchaseCount) {
				diff = diff / data.shellPurchaseCount;
			}
			money -= diff * data.magPrice;
			inventory = {...inventory};
		}
	}

	function removeMagazine(event, item, shouldRemoveAll) {
		if (event) {
			event.preventDefault()
		}
		const data = itemData[item.id];
		if (item.ammo !== undefined) {
			const startingAmmo = item.ammo;
			item.ammo -= data.shellPurchaseCount || 1;
			if (shouldRemoveAll) {
				item.ammo = 0;
			}
			if (item.ammo < 0) {
				item.ammo = 0;
			}
			let diff = startingAmmo - item.ammo;
			if (data.shellPurchaseCount) {
				diff = diff / data.shellPurchaseCount;
			}
			money += diff * data.magPrice;
			inventory = {...inventory};
		}
	}

	function addMagazineHover(item) {
		moneyPeak = money - itemData[item.id].magPrice;

		return () => {moneyPeak = undefined}
	}

	function removeMagazineHover(item) {
		if (item.ammo > 0) {
			moneyPeak = money + itemData[item.id].magPrice;
		}

		return () => {moneyPeak = undefined}
	}

	function sellAll() {
		const keys = Object.keys(inventory);
		for (const key of keys) {
			const item = inventory[key];
			if (!item) {
				continue;
			}
			if (item.id === 'knife') {
				removeMagazine(null, item, true);
				continue;
			}
			deselectItem(item.id);
		}

		itemData = {...itemData};
	}

	function fillAll() {
		const keys = Object.keys(inventory);
		for (const key of keys) {
			const item = inventory[key];
			if (!item) {
				continue;
			}
			addMagazine(null, item, true);
		}

		itemData = {...itemData};
	}
</script>

<main bind:this={main}>
	<img src='images/background-ui.png' alt="Background image of gameplay screenshot" class="background-img"
		bind:this={background}
	>
	<div
		class='ui-layer'
		bind:this={uiLayer}
	>
		<div class='shop'>
			<div class='money-container'>
				<div class={`money${money < 0 ? ' negative' : ''}`}>€ {money}</div>
				{#if moneyPeak !== undefined}
					<div class={`money-peak${moneyPeak >= money ? ' positive' : ' negative'}`}>€ {moneyPeak}</div>
				{/if}
			</div>
			{#each Object.keys(categories) as category}
				{#if category !== 'Armor'}
				<Column
					headerName={category}
				>
					{#each categories[category] as item}
						{#if itemData[item]}
							<Weapon
								weaponName={itemData[item].label}
								weaponIcon={itemData[item].icon}
								weaponPrice={itemData[item].price}
								magPrice={itemData[item].magPrice}
								isSelected={itemData[item].isSelected}
								isDisabled={itemData[item].isDisabled}
								onHover={(e) => { return onWeaponHover(itemData[item]) }}
								onClick={(e) => { onWeaponClick(e, itemData[item])}}
								onRightClick={(e) => { onWeaponRightClick(e, itemData[item])}}
							></Weapon>
						{/if}
					{/each}
				</Column>
			{/if}
			{/each}

			<Column
				headerName={"Armor"}
				width={144}
			>
				{#each armor as ar}
					{#if itemData[ar]}
						<Armor
							armorIcon={itemData[ar].icon}
							armorPrice={itemData[ar].price}
							isSelected={itemData[ar].isSelected}
							isDisabled={itemData[ar].isDisabled}
							onHover={(e) => { return onWeaponHover(itemData[ar]) }}
							onClick={(e) => { onWeaponClick(e, itemData[ar])}}
							onRightClick={(e) => { onWeaponRightClick(e, itemData[ar])}}
						></Armor>
					{/if}
				{/each}
			</Column>
		</div>
		<div class='inventory'>
			<h2>Inventory</h2>
			<div class="header">
				<div class="header1">Weapon</div>
				<div class="header2">Ammo</div>
			</div>
			<div id="inventory-contents">
				{#each Object.keys(inventory) as item}
					{#if inventory[item] && inventory[item].ammo !== undefined}
						<Inventory
							icon={inventory[item].icon}
							label={inventory[item].label}
							ammo={inventory[item].ammo}
							onClick={() => { deselectItem(inventory[item].id) }}
							onIncrement={(e) => { addMagazine(e, inventory[item]) }}
							onMegaIncrement={(e) => { addMagazine(e, inventory[item], true) }}
							onDecrement={(e) => { removeMagazine(e, inventory[item]) }}
							onMegaDecrement={(e) => { removeMagazine(e, inventory[item], true) }}
							onIncrementHover={() => { return addMagazineHover(inventory[item]) }}
							onDecrementHover={() => { return removeMagazineHover(inventory[item]) }}
						></Inventory>
					{/if}
				{/each}
				<div class="grenade-container">
					{#each Object.keys(inventory) as item}
						{#if inventory[item] && inventory[item].ammo === undefined}
							<Inventory
								icon={inventory[item].icon}
								label={inventory[item].label}
								onClick={() => { deselectItem(inventory[item].id) }}
							></Inventory>
						{/if}
					{/each}
				</div>
			</div>
			<div class="button-container">
				<button on:click={sellAll}>Sell All</button>
				<button on:click={fillAll}>Fill Ammo</button>
			</div>
		</div>
	</div>
</main>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Mono:400,700&display=swap');

	:global(body) {
		padding: 0;
		margin: 0;
		background: #0a0a0a;
		overflow: hidden;
		color: #FDFDFD;
		font-family: 'Roboto Mono', monospace;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 17px;
	}

	:global(button) {
		background: none;
		border: none;
		margin: 0;
		color: #FDFDFD;
	}

	:global(button:hover) {
		background: rgba(0, 0, 0, 0.3);
	}

	:global(button:not(:disabled):active) {
		background: none;
	}

	main {
		margin: 0;
		padding: 0;
		width: 2562px;
		height: 1440px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.grenade-container {
		display: grid;
		grid-template-columns: repeat(3, 33.33%);
		grid-column: 1 / span 2;
	}

	.inventory {
		width: 569px;
		margin-right: 2em;
	}

	.inventory .button-container {
		display: grid;
		grid-template-columns: 50% 50%;
		grid-template-rows: 100%;
	}

	.inventory button {
		background: rgba(51, 51, 51, 0.7);
		height: 67px;
		margin-top: 6px;
	}

	.inventory button:hover {
		background: rgba(22, 22, 22, 0.7);
	}

	.inventory button:active {
		background: rgba(61, 61, 61, 0.7);
	}

	.inventory button:nth-child(1) {
		margin-right: 3px;
	}

	.inventory button:nth-child(2) {
		margin-left: 3px;
	}

	.inventory h2 {
		font-weight: 300;
		font-size: 36px;
		margin: 0;
		margin-bottom: 13px;
		margin-top: 20px;
	}

	.inventory .header {
		display: grid;
		grid-template-columns: 50% 50%;
		width: 100%;
		background: rgba(156, 44, 44, 0.75);
		height: 43px;
		justify-items: center;
		align-items: center;
	}

	#inventory-contents {
		display: grid;
		background: rgba(16, 16, 16, 0.75);
		width: 100%;
		height: 755px;
		grid-template-columns: 50% 50%;
		grid-template-rows: 20% 20% 20% 20% 20%;
	}

	.shop {
		padding: 2em;
		display: flex;
		flex-wrap: wrap;
	}

	.money-container {
		width: 100%;
		margin-bottom: 0.5em;
	}

	.money, .money-peak {
		word-spacing: -6px;
		font-size: 26px;
		display: inline;
	}

	.money.negative {
		color: rgb(214, 46, 46);
	}

	.money-peak.positive {
		color: rgb(48, 214, 84);
	}

	.money-peak.negative {
		color: rgb(214, 46, 46);
	}

	.ui-layer {
		position: absolute;
		display: flex;
		width: 100%;
		justify-content: space-between;
	}

	.top-bar {
		width: 100%;
		background: rgba(0, 0, 0, 0.85);
		text-transform: uppercase;
		text-align: left;
	}

	.top-bar h1 {
		font-weight: 300;
		margin: 0;
		padding: 0.6em 1em;
		font-size: 24px;
	}
</style>